<template>
    <div>
        <b-modal size="xl" :id="id" ref="finder" hide-footer :title="prefix + title">
            <TipoAlteracaoList @close="rowSelect" :prefix="prefix + title + ' >'" />
        </b-modal>
        <lg-form-input-finder v-model="localValue" fieldDescription="descricao" :label="label"
            invalidFeedback="Tipo Alteração deve ser informado!" description="" @handleClean="handleClear">
            <template #prepend>
                <b-button @click="show" class="btn-input-finder" pressed>
                    <b-icon icon="search" />
                </b-button>
            </template>
        </lg-form-input-finder>
    </div>
</template>

<script>
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue";
import TipoAlteracaoList from "@/modules/cadastros/tipo-alteracao/TipoAlteracaoList.vue";

export default {
    components: { TipoAlteracaoList, LgFormInputFinder },

    props: {
        id: {
            type: String,
            default: "finderTipoAlteracao",
        },
        value: Object,
        prefix: {
            type: String,
            default: "",
        },
        label: {
            type: String,
            default: "Tipo de Alteração:",
        },
    },

    data() {
        return {
            localValue: this.value,
            title: "Tipo de Alteração",
        };
    },

    watch: {
        value(newValue) {
            this.localValue = newValue;
        },
        localValue(newValue) {
            this.$emit("input", newValue);
        },
    },

    methods: {
        async show() {
            await this.$refs.finder.show();
        },

        handleClear() {
            this.localValue = null;
            this.$emit("input", null);
        },

        rowSelect(item) {
            this.localValue = item;
            this.$refs.finder.hide();
            this.$emit("input", item);

        },
    },
};
</script>
